module.exports = __webpack_public_path__ + "static/img/founder-pic.b86196b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/founder-pic.png
// module id = /bt6
// module chunks = 0